import { DistributorDataTypeV2, SellerIntegrationType } from 'opensolar-common'
import { Grid, styled } from 'opensolar-ui'
import SupplierLogoWithFallback from './SupplierLogoWithFallback'

const Container = styled(Grid, { name: 'Container' })(() => ({
  gap: '4px',
  justifyContent: 'inherit',
}))

const TextFallbackItem = styled(Grid, { name: 'TextFallbackItem' })({
  minWidth: 0,
  maxWidth: '100%',
  width: '100%',
})

const sortByPriceOrderingV2 = <T extends { price: number }>(arr: T[]): T[] => {
  return [...arr].sort((a, b) => a.price - b.price)
}

interface DistributorChipsProps {
  ordering_v2: DistributorDataTypeV2[]
  enabledSellerIntegrations?: SellerIntegrationType[]
}

const DistributorChips = ({ ordering_v2, enabledSellerIntegrations = [] }: DistributorChipsProps) => {
  const distributors = sortByPriceOrderingV2(ordering_v2).slice(0, 1)

  return (
    <Container container>
      {distributors.map((order) => {
        const config = enabledSellerIntegrations.find((integration) => integration.filterKey === order.distributor)
        if (!config) {
          return null
        }

        const isTextFallback = !config.logoUrl

        if (isTextFallback) {
          return (
            <TextFallbackItem item key={config.filterKey}>
              <SupplierLogoWithFallback logoUrl={config.logoUrl} name={config.name} />
            </TextFallbackItem>
          )
        }

        return (
          <Grid item key={config.filterKey}>
            <SupplierLogoWithFallback logoUrl={config.logoUrl} name={config.name} />
          </Grid>
        )
      })}
    </Container>
  )
}

export default DistributorChips
